import actionTypes from '../../constants/actions/importarClientesExcel/importarClientesExcel'

export function initialState () {
  return {
    showModalImportarClientesExcel: false,
    archivoExcel: [],
    listImportarClientesExcel: []
  }
}

export function abrirModalImportarClientesExcel (state, {listCopiaSeguridad}) {
  console.log("REDUCEEEER")
  return {
    ...state,
    showModalImportarClientesExcel: true
  }
}

export function cerrarModalImportarClientesExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarClientesExcel: false,
    archivoExcel: [],
    listImportarClientesExcel: []
  }
}

export function subirArchivosImportarClientesExcel (state, {archivoExcel}) {
  return {
    ...state,
    archivoExcel: archivoExcel
  }
}

export function submitImportarClientesExcelSuccess (state, {listImportarClientesExcel}) {
  return {
    ...state,
    listImportarClientesExcel: listImportarClientesExcel
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case actionTypes.ABRIR_MODAL_IMPORTAR_CLIENTES_EXCEL:
      return abrirModalImportarClientesExcel(state, action)
     case actionTypes.CERRAR_MODAL_IMPORTAR_CLIENTES_EXCEL:
      return cerrarModalImportarClientesExcel(state, action)
     case actionTypes.SUBIR_ARCHIVOS_IMPORTAR_CLIENTES_EXCEL:
      return subirArchivosImportarClientesExcel(state, action)
     case actionTypes.SUBMIT_IMPORTAR_CLIENTES_EXCEL_SUCCESS:
      return submitImportarClientesExcelSuccess(state, action)
    default:
      return state
  }
}
